<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    value?: number
    label: string
  }>(),
  {
    value: 0,
  },
)

const radius = 18
const circumference = 2 * Math.PI * radius

const dashArray = computed(() => {
  const clamped = Math.min(Math.max(props.value, 0), 100)

  return `${(clamped / 100) * circumference} ${circumference}`
})
</script>

<template>
  <svg viewBox="0 0 44 44" class="size-12 shrink-0" role="img" :aria-label="label">
    <defs>
      <linearGradient id="finest-gauge-compact" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#1566e9" />
        <stop offset="55%" stop-color="#0da9a1" />
        <stop offset="100%" stop-color="#08d570" />
      </linearGradient>
    </defs>
    <circle cx="22" cy="22" :r="radius" fill="none" class="stroke-surface-3" stroke-width="4" />
    <circle
      cx="22"
      cy="22"
      :r="radius"
      fill="none"
      stroke="url(#finest-gauge-compact)"
      stroke-width="4"
      stroke-linecap="round"
      :stroke-dasharray="dashArray"
      transform="rotate(-90 22 22)" />
    <text x="22" y="22" text-anchor="middle" dominant-baseline="central" class="fill-ink text-[12px] font-semibold">
      {{ value }}%
    </text>
  </svg>
</template>
